(() => {
  const updateBanner = () => {
    document.querySelectorAll('.banner-message[data-show-happy-hour="1"]').forEach((banner) => {
      const venue = get_current_venue_info();

      if(venue?.happy_hour_banner && (!venue?.happy_hour_only_banner || get_is_happy_hour_at_current_venue())){
        let bannerMessage = '';

        if (venue.happy_hour_banner_url){
          bannerMessage = `<a href="${venue.happy_hour_banner_url}">${venue.happy_hour_banner}</a>`;
        }else{
          bannerMessage = venue.happy_hour_banner;
        }

        banner.innerHTML = bannerMessage;
        if(banner.dataset.originalMessage == ''){
          banner.closest('section').classList.remove('hidden!');
        }
      }else{
        banner.innerHTML = banner.dataset.originalMessage;
        if(banner.dataset.originalMessage == ''){
          banner.closest('section').classList.add('hidden!');
        }
      }
    });
  }

  updateBanner();
  document.body.addEventListener('venueChanged', updateBanner);
  document.body.addEventListener('venueChanged', () => {
    updateBanner();
    
    setTimeout(() => {
      updateBanner();
    }, 300)
  });
})();